import React, { memo } from 'react'
import styles from './index.less'
import CustomNodeWrapper from '../../configuration/wrapper'
import type { InputNodeData } from '../types'
import type { ComponentType } from 'react'
import type { NodeProps } from 'reactflow'

function InputNodeRender({ data, selected }: NodeProps<InputNodeData>) {
  return (
    <CustomNodeWrapper nodeData={data} selected={selected}>
      <span className={`${styles.nodeText}`}>{data.nodeName}</span>
    </CustomNodeWrapper>
  )
}

const InputNode: ComponentType<NodeProps<InputNodeData>> = memo(InputNodeRender)

export default InputNode
